// extracted by mini-css-extract-plugin
export default {"readonlyStyle":"FormSection_readonlyStyle__Kicmd"};